.wrapper {
  position: relative;
}

.input {
  padding-inline-end: 45px;
}

.copyButton {
  position: absolute;
  inset-inline-end: 1px;
  top: 1px;
  padding: 7px;
}
